import { Action, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Account } from '../../types/account';
import { startSessionSuccess } from '../actions/session.actions';
import { isChooseAccountSessionState, SessionState } from '../../types/session';
import { RootState } from '../store';
import { changeSessionState } from './session.slice';

type AccountState = {
	init: true;
	id: string | undefined; // chosen account id
	accounts: Array<Account>;
};

type State = AccountState | { init: false };

const initialState: State = { init: false } as State;

export const accountSlice = createSlice({
	name: 'session/account',
	initialState,
	reducers: {
		chooseAccount(state, action: PayloadAction<string>) {
			if (state.init === false) return state;

			const accounts = state.accounts;
			const id = action.payload;
			if (!accounts.find((account) => account.id === id)) return state;

			return {
				...state,
				id
			};
		}
	},
	extraReducers: (builder) => {
		builder.addMatcher(isSessionStateChange, (accountState, action) => {
			const sessionState = action.payload;
			if (!isChooseAccountSessionState(sessionState)) return accountState;

			const accounts = sessionState.result.accounts;
			return {
				init: true,
				id: undefined,
				accounts
			};
		});
	}
});

const isSessionStateChange = (action: Action): action is PayloadAction<SessionState> => {
	return action.type === startSessionSuccess.type || action.type === changeSessionState.type;
};

// SELECTORS

export const selectAccounts = (state: RootState) => {
	if (!state.account.init) return undefined;
	return state.account.accounts;
};
